<template>
    <a :href="target" :download="downloadName"><fa-icon icon="file-download" /> {{ title }}</a>
</template>

<script>
    export default {
        name: "FileDownload",
        props: {
            isPng: {type: Boolean, default: false},
            title: {type: String, default: 'Download'},
            data: {type: String, default: ''},
            downloadName: {type: String, default: 'some.feature'}
        },
        computed: {
            target() {
                return this.data.length > 0 ?
                    (this.isPng ? this.data : 'data:text/plain,' + encodeURIComponent(this.data)) :
                    'javascript:;';
            }
        }
    }
</script>
